<template>
	<div>
		<NavigationItem to="users" type="link" name="Users" description="hhhdsf" icon="mdi-account-group"></NavigationItem>

		<NavigationGroup 
			name="Assessments" 
			icon="mdi-poll" 
			iconcolor="grey"
			description=" "
			type="collapse"
			:children="[
				{name: 'Settings', type: 'link', to: 'assessment-settings', icon: 'mdi-cog', description: 'Assessment set up' },
				{name: 'Surveys', type: 'link', to: 'surveys', icon: 'mdi-view-list', description: 'Any type of survey' },
				{name: 'New Survey', type: 'link', to: 'new-survey', icon: 'mdi-plus-circle', description: 'New Survey' },
			]"
			>
		</NavigationGroup>
	</div>
</template>

<style lang="less">
	
</style>

<script type="text/javascript">
	// import Vuex from "vuex";
	import NavigationItem from "@/components/elements/NavigationItem"
	import NavigationGroup from "@/components/elements/NavigationGroup"


	export default {
		name: "AdminNav", 
		props: {
			
		},
		data: () => {
			return {

			}
		},
		components: {
			NavigationItem,
			NavigationGroup
		},
		// computed: {
			// ...Vuex.mapState({})
		// },
		// methods: {
		// }
		// created(){
			
		// }

	}
</script>